module.exports = __webpack_public_path__ + "static/media/educazione-finanziaria_debiti.3149c794.png";